import Vue from 'vue';
import VueRouter from 'vue-router';
import FiresList from '../components/FiresList';
import FormFire from '../components/FormFire';


Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        redirect: '/form-fire',
    },
    {
        path: '/form-fire',
        name: 'form-fire',
        component: FormFire,
    },
    {
        path: '/fires-list',
        name: 'fires-list',
        component: FiresList,
    },
]



const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
  });


export default router;
